/**
 * Alert Component JavaScript
 * Handles close functionality with animation
 */

(function() {
  function initAlerts() {
    const alerts = document.querySelectorAll('[data-alert]');
    
    alerts.forEach(alert => {
      if (alert._alertInitialized) return;
      alert._alertInitialized = true;

      const closeBtn = alert.querySelector('.alert__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          // Add closing animation
          alert.setAttribute('data-closing', '');
          
          // Remove after animation completes
          alert.addEventListener('animationend', () => {
            alert.remove();
          }, { once: true });
        });
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAlerts);
  } else {
    initAlerts();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', initAlerts);
})();

